import React, { useState } from "react";

const SIZES = {
  xs: "w-8 h-8 text-xs",
  sm: "w-10 h-10 text-sm",
  md: "w-14 h-14 text-lg",
  lg: "w-20 h-20 text-2xl",
  xl: "w-28 h-28 text-4xl",
};

export default function Avatar({ src, name = "?", size = "md", crown = false, className = "" }) {
  const [err, setErr] = useState(false);
  const cls = `${SIZES[size]} rounded-full object-cover ring-2 ring-[#9C42F5]/50 ${crown ? "ring-[#FFC83D]/70 shadow-[0_0_16px_rgba(255,200,61,0.4)]" : ""} ${className}`;
  if (!src || err) {
    return (
      <div className={`${cls} bg-gradient-to-br from-[#7625D8] to-[#EF4D9A] flex items-center justify-center font-black text-white select-none`}>
        {(name || "?").trim().charAt(0)}
      </div>
    );
  }
  return <img src={src} alt={name} loading="lazy" onError={() => setErr(true)} className={cls} />;
}
